module.exports = __webpack_public_path__ + "static/media/mcnick.ab71dbfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mcnick.png
// module id = 92
// module chunks = 0